import { Box, Typography, Link as MuiLink } from "@mui/material";
import { useState } from "react";
import { containerStyles, imageStyles, textContainerStyles, titleContainerStyles, titleTextStyles, subtitleContainerStyles, subtitleWrapperStyles, subtitleTextStyles, underlineStyles } from "./CategoryShowcaseStyles";
import { IMAGE_BRIGHTNESS, TEXTS } from "./CategoryShowcaseConstants";
import {useNavigate} from "react-router-dom";

export interface CategoryImage {
  src: string;
  alt: string;
  title: string;
  link: string;
}

interface ImageWithOverlayProps {
  image: CategoryImage;
  section: string;
}

export const ImageWithOverlay: React.FC<ImageWithOverlayProps> = ({ image, section }) => {
  const [isHovered, setIsHovered] = useState(false);
  const isBottomRight = section === "bottomRight";
  const navigate = useNavigate();

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);


  const handleLinkClick = (e: React.MouseEvent) => {
    // click izquierdo normal ? interceptar navegación SPA
    const isLeftClick = e.button === 0;
    const isModified = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;

    if (isLeftClick && !isModified) {
      e.preventDefault();
      navigate(image.link);
    }
    // click derecho, scroll click, ctrl+click ? dejan comportamiento nativo
  };

  return (
    <MuiLink
      href={image.link}
      underline="none"
      color="inherit"
      onClick={handleLinkClick}
      sx={{
          ...containerStyles,
          display: "block",
          cursor: "pointer",
          position: "relative",
          textDecoration: "none",
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Box
        component="img"
        src={image.src}
        alt={image.alt}
        sx={{
          ...imageStyles,
          filter: isHovered 
            ? `brightness(${IMAGE_BRIGHTNESS.hover})` 
            : `brightness(${IMAGE_BRIGHTNESS.normal})`,
          transform: isHovered ? "scale(1.05)" : "scale(1)",
        }}
      />

      <Box sx={textContainerStyles}>
        <Box sx={{
          ...titleContainerStyles,
          transform: isHovered ? "translateY(-30px)" : "translateY(0)",
        }}>
          <Typography component="div" sx={titleTextStyles}>
            {image.title}
          </Typography>
        </Box>
        
        <Box sx={{
          ...subtitleContainerStyles,
          opacity: isHovered ? 1 : 0,
        }}>
          <Box sx={subtitleWrapperStyles}>
            <Typography component="div" sx={subtitleTextStyles}>
              {isBottomRight ? TEXTS.ultimasUnidades : TEXTS.miraMas}
            </Typography>
            <Box sx={{
              ...underlineStyles,
              opacity: isHovered ? 1 : 0,
            }} />
          </Box>
        </Box>
      </Box>
    </MuiLink>
  );
};














